import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { Search } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { actions as actionStep, getStep } from "../../../reducers/Step";
import { actions as actionStepOne, getFirstName, getLastName, getPhoneNumber, getDOB } from "../../../reducers/StepOne";
import { actions as actionStepTwo } from "../../../reducers/StepTwo";
import { getTypePay } from "../../../reducers/TypePayment";
import FAMSA from "../../../config/constants";
import axios from "axios";
import { Alert } from "../../Alerts";
import Loading from "../../Loading";
import { dateFormatter, normalizeInput, NotNormalizeInput } from "../../generals/normalizaInput";
import ReactInputMask from "react-input-mask";
/*import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';*/
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const StepOne = () => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const type_pay = useSelector(getTypePay);
    const first_name = useSelector(getFirstName);
    const last_name = useSelector(getLastName);
    const phone_number = useSelector(getPhoneNumber);
    const dob = useSelector(getDOB);
    const [validated, setValidated] = useState({
        first_name: null,
        last_name: null
    });
    const [invalid, setInValid] = useState({
        first_name: null,
        last_name: null
    });
    const [loading, setLoading] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [phone, setPhone] = useState("");
    const [startDate, setStartDate] = useState((dob === "") ? null : new Date(dob));
    const [isOpen, setIsOpen] = useState(null);

    const handleSubmit = async (event) => {
        //event.preventDefault();
        if (first_name === '' && last_name === '') {
            setInValid({ ...invalid, first_name: true, last_name: true })
            setValidated({ ...validated, first_name: false, last_name: false });
        } else {
            setSpinner(true);
            await searchCustomer();
            setInValid({ ...invalid, first_name: false, last_name: false })
            setValidated({ ...validated, first_name: true, last_name: true });
        }
    };

    const searchCustomer = async () => {
        //const datedob = (type_pay === 1) ? dateFormatter(new Date()) : dob;
        const fullURL = FAMSA.SERVER.SERVER + `/api/SearchCustomer?firstName=${first_name}&lastName=${last_name}&phoneNumber=${NotNormalizeInput(phone)}&bod=${dob}&CompanyId=${(type_pay === 1) ? "FAMSAINC" : "LOANS"}`;
        await axios.get(fullURL).then((response) => {
            setLoading(true);
            setSpinner(false);
            console.log('PRUEBA', response.data.StatusCode);
            if (response.data.StatusCode === 0) {
                setLoading(false);
                distpatch(actionStepTwo.setAccountNo(response.data.Data.AccountNo));
                distpatch(actionStepTwo.setCompanyCode(response.data.Data.CompanyCode));
                distpatch(actionStepTwo.setContractNo(response.data.Data.ContractNo));
                distpatch(actionStepTwo.setEmail(response.data.Data.Email));
                distpatch(actionStepTwo.setName(response.data.Data.Name));
                distpatch(actionStepTwo.setPhone(response.data.Data.Phone));
                distpatch(actionStepTwo.setStore(response.data.Data.Store));
                distpatch(actionStepTwo.setSSN4(response.data.Data.SSN4));
                distpatch(actionStepTwo.setCustomerStatus(response.data.Data.CustomerStatus));
                distpatch(actionStep.nextPage());
            } else {
                setLoading(false);
                Alert("danger", "", response.data.Data.Errors[0].Message);
            }
        }).catch(error => {
            setSpinner(false);
            if (error.response.data.StatusCode === 1) {
                Alert("danger", "Error", error.response.data.Data.Errors[0].Message);
            } else if (error.response.status === 400) {
                Alert("danger", "Error", error.response.data.Message);
            } else if(error.response.status === 401) {
                Alert("warning", "Warning!", intl.formatMessage({ id: "step.report.support-alert" }));
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        })
    }

    const handleFirstName = (e, value) => {
        e.preventDefault();
        if (value !== '') {
            setInValid({ ...invalid, first_name: false })
            setValidated({ ...validated, first_name: true });
            distpatch(actionStepOne.setFirstName(value));
        } else {
            setInValid({ ...invalid, first_name: true })
            setValidated({ ...validated, first_name: false });
        }
    }

    const handleLastName = (e, value) => {
        e.preventDefault();
        if (value) {
            setInValid({ ...invalid, last_name: false })
            setValidated({ ...validated, last_name: true });
            distpatch(actionStepOne.setLastName(value));
        } else {
            setInValid({ ...invalid, last_name: true })
            setValidated({ ...validated, last_name: false });
        }
    }

    const handlePhoneNumber = (e, value) => {
        e.preventDefault();
        setPhone(normalizeInput(value));
    }

    const handleDOB = (value) => {
        //debugger
        setStartDate(value);
        distpatch(actionStepOne.setDOB((value === null) ? "" : dateFormatter(value)));
    }

    return (
        <>
            {(!loading) ?
                <Form>
                    <Row className='justify-content-center mx-3 my-3'>
                        <Col sm={{ span: 12 }} md={{ span: 12 }} className="mb-3">
                            <span className="famsa-text-red"><FormattedMessage id="step.one.span.mandatory" /></span>
                        </Col>
                        <Col sm={{ span: 12 }} md={{ span: 6 }}>
                            <Form.Group className="mb-3" controlId="validationFirstname">
                                <Form.Label><FormattedMessage id="step.one.firstname" />: <span className="famsa-text-red">*</span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder={intl.formatMessage({ id: "step.one.firstname" })}
                                    onChange={(e) => handleFirstName(e, e.target.value)}
                                    isInvalid={invalid.first_name}
                                    isValid={validated.first_name} />
                            </Form.Group>
                        </Col>
                        <Col sm={{ span: 12 }} md={{ span: 6 }}>
                            <Form.Group className="mb-3" controlId="validationLastname">
                                <Form.Label><FormattedMessage id="step.one.lastname" />:  <span className="famsa-text-red">*</span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder={intl.formatMessage({ id: "step.one.lastname" })}
                                    onChange={(e) => handleLastName(e, e.target.value)}
                                    isInvalid={invalid.last_name}
                                    isValid={validated.last_name} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mx-3 my-3'>
                        <Col sm={{ span: 12 }} md={{ span: 6 }}>
                            <Form.Group className="mb-3" controlId="validationPhonenumber">
                                <Form.Label><FormattedMessage id="step.one.phonenumber" />: <span className="famsa-text-red">*</span></Form.Label>
                                <ReactInputMask
                                    className="form-control"
                                    mask="(999) - 999 - 9999"
                                    maskChar={null}
                                    value={phone}
                                    placeholder={intl.formatMessage({ id: "step.one.phonenumber" })}
                                    onChange={(e) => handlePhoneNumber(e, e.target.value)} />
                            </Form.Group>
                        </Col>
                        {(type_pay === 2) ?
                            <Col sm={{ span: 12 }} md={{ span: 6 }}>
                                <Form.Group className="mb-3" controlId="validationPhonenumber">
                                    <Form.Label><FormattedMessage id="step.one.dob" />:</Form.Label>
                                    <Col sm={{ span: 12 }} md={{ span:  12}} className="famsa-input-datepicker">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleDOB}
                                            customInput={
                                                <ReactInputMask 
                                                    className="form-control"
                                                    mask="99/99/9999"
                                                    maskChar={null}
                                                    value={dob}
                                                    placeholder={"mm/dd/yyyy"}
                                                    onChange={(e) => handleDOB(e, e.target.value)}
                                                />}
                                            dropdownMode="select"
                                            isClearable
                                            placeholderText="mm/dd/yyyy"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            : null}
                    </Row>
                    <Row className="justify-content-end mx-3 my-3">
                        <Col sm={{ span: 5 }} md={{ span: 4 }}>
                            <Button className="famsa-btn-green famsa-btn-w fs-5" onClick={handleSubmit} disabled={spinner}>
                                {(spinner) ?
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> Loading...</>
                                    :
                                    <><Search className="me-3" /><FormattedMessage id="step.one.submit" /></>}
                            </Button>
                        </Col>
                    </Row>
                </Form>
                : <Loading />}
        </>
    );
}

export default StepOne;